<template>
  <div id="routelog">

    <div class="greenSpinner" v-show="projectLoading">
      <md-spinner md-indeterminate :md-size="90" :md-stroke="1.8" class="md-primary" md-theme="teal"></md-spinner>
      <p class="md-subheading" style="top:45vh; position: relative; display:block; z-index: 120; text-align:center; color:#ffffff;">Daten werden geladen</p>
    </div>

    <md-toolbar class="listBar">
      <md-button v-if="isQRcode" class="md-icon-button" @click.native="goPreview()">
        <md-icon>close</md-icon>
      </md-button>

      <md-button v-else class="md-icon-button" @click.native="goBack()">
        <md-icon style="color:#ffffff !important;">close</md-icon>
      </md-button>
      <h2 class="md-title">{{ pageTitle }}</h2>

      <div v-if="!selectTrash">
        <md-menu v-if="climboTab == 'staTab'" :md-align-trigger="true" :md-offset-x="154" md-offset-y="12" md-direction="bottom left" md-size="3">
          <md-button class="md-icon-button" md-menu-trigger>
            <md-icon>date_range</md-icon>
          </md-button>

          <md-menu-content>
            <md-menu-item @click="changeTimePeriod('all'), getUserKPI()">
              <span>Alles</span>
            </md-menu-item>
            <md-menu-item @click="changeTimePeriod('last_year'), getUserKPI()">
              <span>letztes Jahr</span>
            </md-menu-item>
            <md-menu-item @click="changeTimePeriod('last_six_months'), getUserKPI()">
              <span>letzte 6 Monate</span>
            </md-menu-item>
            <md-menu-item @click="changeTimePeriod('last_three_months'), getUserKPI()">
              <span>letzte 3 Monate</span>
            </md-menu-item>
            <md-menu-item @click="changeTimePeriod('last_month'), getUserKPI()">
              <span>letzter Monat</span>
            </md-menu-item>
            <md-menu-item @click="changeTimePeriod('this_month'), getUserKPI()">
              <span>dieser Monat</span>
            </md-menu-item>
          </md-menu-content>
        </md-menu>

        <md-menu v-else :md-align-trigger="true" :md-offset-x="154" md-offset-y="12" md-direction="bottom left" md-size="5">
          <md-button class="md-icon-button" md-menu-trigger>
            <md-icon>more_vert</md-icon>
          </md-button>

          <md-menu-content v-if="climboTab == 'logTab'">
            <md-menu-item @click="selectTrash = !selectTrash, changeProjectTrash(false), enableDelete()">
              <span>Route aus Routenbuch löschen</span>
              <md-icon>delete</md-icon>
            </md-menu-item>

            <md-menu-item @click="goRefresh()">
              <span>Refresh</span>
              <md-icon>cached</md-icon>
            </md-menu-item>
          </md-menu-content>

          <md-menu-content v-else-if="climboTab == 'proTab'">
            <md-menu-item @click="selectTrash = !selectTrash, changeProjectTrash(true)">
              <span>Route aus Routenbuch löschen</span>
              <md-icon>delete</md-icon>
            </md-menu-item>

            <md-menu-item @click="goRefresh()">
              <span>Refresh</span>
              <md-icon>cached</md-icon>
            </md-menu-item>
          </md-menu-content>

          <md-menu-content v-else-if="climboTab == 'whoTab'">
            <!-- <md-menu-item @click="changeProjectTrash(false), changeProfileEdit(true), changeImagePreview('')">
              <span>Edit Profile</span>
              <md-icon>edit</md-icon>
            </md-menu-item> -->
            <md-menu-item @click="goRefresh()">
              <span>Refresh</span>
              <md-icon>cached</md-icon>
            </md-menu-item>
          </md-menu-content>
        </md-menu>

    </div>
    <div v-else>

      <md-button v-if="climboTab == 'logTab'" @click="selectTrash = !selectTrash, changeProjectTrash(false)" class="md-icon-button">
        <md-icon>done</md-icon>
      </md-button>

      <md-button v-if="climboTab == 'proTab'" @click="selectTrash = !selectTrash, changeProjectTrash(false)" class="md-icon-button">
        <md-icon>done</md-icon>
      </md-button>

      <md-button v-if="climboTab == 'whoTab'" @click="" class="md-icon-button">
        <md-icon>done</md-icon>
      </md-button>
    </div>

    </md-toolbar>

    <md-dialog-confirm
      :md-title="erase.title"
      :md-content-html="erase.contentHtml"
      :md-ok-text="erase.ok"
      :md-cancel-text="erase.cancel"
      @open="onOpen"
      @close="onErase"
      ref="dialog4">
    </md-dialog-confirm>

    <md-dialog-alert
      :md-title="alertRoute.title"
      :md-content-html="alertRoute.contentHtml"
      @open="onOpen"
      @close="onClose"
      ref="dialog5">
    </md-dialog-alert>

    <div style="position:relative; top:64px;">

      <md-tabs id="meinTenduTab" :md-navigation="tabNav" md-centered class="md-transparent" ref="meinClimbo" @change="alert($refs.meinClimbo.activeTab), makeActiveTab()">

        <md-tab id="logTab" :md-active="logTab" md-label="Routenbuch" md-icon="local_library">
          <div style="margin-top:70px !important;"></div>

          <md-list v-for="(udates, key, index) in userLogs" :key="index">

            <md-list-item md-expand-multiple v-for="logDates in orderBy(udates)" v-bind:key="logDates.entries[0].date"
                          @click="showLogs = false"
                          :class="{ 'md-active': showLogs }">

              <span style="width:310px !important;" class="md-caption">
                <strong>
                  {{ logDates.date | localdate }}
                  <span style="width:30px !important; overflow:hidden !important;">{{ key }}</span>
                  - {{ logDates.entries.length | geklettert }} geklettert
                </strong>
              </span>

              <md-list-expand>
                  <md-list class="md-triple-line">
                    <md-list-item v-for="logInfo in orderBy(logDates.entries)" v-bind:key="logInfo.id">

                      <md-avatar class="md-avatar-icon md-primary" style="color:white; padding-top:8px;">
                        {{logInfo.route.grade }}
                      </md-avatar>

                      <div class="md-list-text-container" @click="logActive(logInfo)" style="width:120px;">
                        <span class="md-body-2" style="word-break: normal; overflow:hidden; white-space:normal;">{{ logInfo.route.routeName }}</span>
                        <div>
                          <span v-if="!logInfo.styles[0]"></span>
                          <span v-else>{{ logInfo.styles[0] | stylesFilter }}</span>
                          <span v-if="logInfo.ratingStatement">{{ logInfo.ratingStatement.attributes | skillsFilter | attributesFilter }}</span>
                        </div>

                        <p v-if="logInfo.ratingStatement" class="md-body-2">Meine Bewertung: {{ logInfo.ratingStatement.grade }}</p>
                        <span class="md-caption" style="word-break: normal; white-space:normal; padding-bottom:10px;">{{ logInfo.comment }}</span>

                        <!-- TO CHECK THE RECENT DATE LOG INSIDE THE SAME DATE (TIMESTAMP HOURS)
                        <strong class="md-caption"> {{ (logInfo.date) }} </strong> -->
                      </div>

                      <div v-if="selectTrash">
                        <md-button style="margin-right:-6px !important;" class="md-icon-button md-list-action md-accent" @click="makeActive(logInfo), openDialog('dialog4')">
                          <md-icon style="font-size:28px">remove_circle</md-icon>
                        </md-button>
                      </div>

                      <div v-else>
                        <md-rating-bar v-if="logInfo.ratingStatement" v-model="logInfo.ratingStatement.rating" class="md-accent" md-theme="orange" disabled></md-rating-bar>
                      </div>

                      <md-divider class="md-inset"></md-divider>
                    </md-list-item>
                  </md-list>

              </md-list-expand>
            </md-list-item>
          </md-list>

        </md-tab>

        <md-tab id="proTab" :md-active="proTab" md-label="Projekte" md-icon="assignment">
          <ClimboProjects></ClimboProjects>
        </md-tab>

        <md-tab id="staTab" :md-active="staTab" md-label="Statistik" md-icon="equalizer">
          <ClimboStatics></ClimboStatics>
        </md-tab>

        <md-tab id="whoTab" :md-active="whoTab" md-label="Profil" md-icon="person">
          <ClimboProfile></ClimboProfile>

        </md-tab>
      </md-tabs>
    </div>
  </div>
</template>

<script>
import ClimboProfile from './ClimboProfile'
import ClimboProjects from './ClimboProjects'
import ClimboStatics from './ClimboStatics'

import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

export default {
  name: 'routelog',
  components: {
    ClimboProfile,
    ClimboProjects,
    ClimboStatics
  },

  data () {
    return {
      showLogs: true,
      logTab: true,
      staTab: false,
      proTab: false,
      whoTab: false,

      tabNav: false,

      userLogs: [],
      userArray: [],
      newDate: [],

      numLogs: 0,
      selectTrash: false,
      disableDetails: false,

      climbedStatements: '',

      activeDetails: [],
      pageTitle: 'Loading...',

      erase: {
        title: '',
        link: '',
        contentHtml: 'Route wirklich aus Routenbuch löschen?',
        ok: 'Löschen',
        cancel: 'Abbrechen'
      },

      alertRoute: {
        title: '',
        contentHtml: 'Diese Route wurde leider schon abgeschraubt',
      }
    }
  },

  created () {
    if (!this.validUser.hash) {
      window.location.href = '/'
      // this.$router.push('/')
    } else {
      this.gettingStatements()
      this.getUserKPI()
    }
  },

  computed: {
    ...mapState([
      'isSidebar',
      'sectorDetails',
      'userPrivileges',
      'validUser',
      'projectTrash',
      'changeSector',
      'climboTab',
      'isQRcode',
      'userKPI',
      'onsightKPI',
      'flashKPI',
      'redpointKPI',
      'timePeriod',
      'userBarOptions',
      'projectLoading',
      'pageLoading'

    ]),

    sectorId () {
      return this.$store.state.sectorDetails.id
    },

    url () {
      return this.$store.state.sectorDetails.overviewImageUrl
    },
  },

  watch: {
    // call again the method if the logs change
    '$route': 'gettingStatements'
  },

  methods: {
    ...mapMutations([
      'changeActive',
      'changeMarker',
      'setSector',
      'changeTab',
      'changeDetails',
      'loadRating',
      'changeProjects',
      'changeProjectTrash',
      'changeProfileEdit',
      'changeProjectsId',
      'changeProjectLoad',
      'changeStatsLoad',
      'changeImagePreview',
      'changeUserKPI',
      'changeFlashKPI',
      'changeOnsightKPI',
      'changeRedpointKPI',
      'changeTimePeriod',
      'changeCutOffDate'
    ]),

    sortDate (arr) {
      return arr.map(e => e).sort().reverse()
    },

    orderBy (list) {
      var sumList = list.map(e => e).sort((a, b) => (b.date) - (a.date))
      return sumList
    },

    enableDelete () {
      this.showLogs = true
      // console.log('enable delete button for each route')
    },
    alert (e) {
      // console.log('alert', e)
      this.changeTab(e)
      // console.log(this.climboTab);
    },

    makeActiveTab(){
      // console.log('climboTab', this.climboTab)
      this.selectTrash = false
      this.changeProjectTrash(false)
    },

    openDialog (ref) {
      this.$refs[ref].open()
    },
    closeDialog (ref) {
      this.$refs[ref].close()
    },

    onOpen () {
      // console.log('Opened')
    },

    onClose(type) {
      console.log('Closed');
    },

    onErase (type) {
      if (type === 'ok') {
        // console.log('the select log will be erase')
        var eraseRouteval = JSON.stringify(this.erase.title)

        this.$http.post(this.erase.link + '/delete', eraseRouteval).then(response => {
          // success callback
          // console.log('success deleting')
          this.gettingStatements()
          this.getUserKPI()
        }, response => {
          // error callback
          // console.log('not success deleting')
        })
        // this.eraseData()
        // this.$router.go(-1)
      }
      // console.log('Closed', type)
    },

    makeActive: function (item) {
      // console.log('the item to delete',item)
      this.erase.title = item.route.routeName
      // console.log('the item routeName', this.erase.title)
      this.erase.link = item.links.deleteClimbingStatement
      // console.log('the link to erase the select climbing is', this.erase.link)
    },

    logActive (item) {
      if (!this.selectTrash) {
        // console.log(item)
        // When a log is changed, the routeDetails will be updated.
        var tempLink = item.links.sector
        var detLink = item.route.links.route
        this.$store.state.changeSector = item.route.sectorName
        // console.log('item', item)
        this.pageTitle = 'Loading...'
        this.loadRating(item.ratingStatement)

        this.$store.dispatch('getSector', tempLink)

        setTimeout(() => {

          this.$http.get(detLink)
            .then(function (response) {
              // console.log('activeDetails', response)
              this.activeDetails = response.data
              this.changeActive(this.activeDetails)
              if(this.validUser.hash) {
                this.$store.dispatch('getRouteStatements', this.activeDetails.links.route)
                // this.$store.dispatch('getRatingStatement', this.activeDetails.links.ratingStatement)
              }

              if (this.activeDetails) {
                this.selectTrash = false
                this.pageTitle = 'Routenbuch'
                this.$router.push('RouteDetails')
              }

              this.changeMarker()
            }, error => {
              console.log('error')
              this.alertRoute.title = item.route.routeName
              this.openDialog('dialog5')
              this.pageTitle = 'Routenbuch'
            })
        }, 600)

      } else {
        // console.log('the item to delete',item)
        this.erase.title = item.route.routeName
      }
    },

    gettingStatements () {
      var userLogLink = this.userPrivileges.links.routeLog
      // console.log(userLogLink)
      if (this.climboTab == 'proTab'){
        this.proTab = true
        this.logTab = false
        this.staTab = false
        this.whoTab = false
      } else if (this.climboTab == 'logTab'){
        this.logTab = true
        this.proTab = false
        this.staTab = false
        this.whoTab = false
      } else if (this.climboTab == 'staTab'){
        this.staTab = true
        this.logTab = false
        this.proTab = false
        this.whoTab = false
      }
      this.$http.get(userLogLink)
        .then((response) => {
          // console.log('success')
          this.showLogs = true
          this.userLogs = Object.freeze(response.data.sectors)
          // console.log('userLogs', response.data)
          // this.userLogs = this.userArray
          this.pageTitle = 'Mein tendu'
          this.showLogs = true
        },
        (response) => {
          // error callback
          // console.log('not success')
        })
    },

    getUserKPI () {
      var userKPILink = this.userPrivileges.links.climbingKPI
      this.$store.dispatch('gettingUserKPI', userKPILink)
    },

    goRefresh () {
      if (this.climboTab == 'proTab') {
        // this.showLogs = false
        this.changeProjectLoad(true)

        var backTab = 'proTab'
        this.changeTab(backTab)
        setTimeout(() => {
          this.changeProjectLoad(false)
        }, 900)
      } else {
        this.showLogs = false
        this.pageTitle = 'Loading...'
        this.gettingStatements()
      }
    },

    goPreview () {
      this.$router.push('/')
      // window.location.href = '/'
    },

    goBack () {
      // var backTab = 'logTab'
      // this.changeTab(backTab)
      // console.log('routeLog climboTab: ', this.climboTab)

      if (this.isSidebar) {
        this.$router.push('/')

      } else if (this.sectorDetails.name !== this.changeSector) {
        this.$store.dispatch('getList', this.sectorDetails.links.routes)
        // console.log('sectorId', this.sectorId, 'changeSector', this.changeSector)
        this.$router.push('/SectorDetails')

      } else {
        // console.log('sectorId', this.sectorId)
        this.$router.push('/RouteList/' + this.sectorId)
      }

      this.selectTrash = false
      this.changeProjectTrash(false)

    }
  }
}

</script>

<style>

  #routelog .md-list {
    padding: 0 !important;
  }

  #routelog .md-tabs .md-tab {
    padding: 0;
  }

  #routelog .md-tab-header-container {
    text-transform:none;
  }

  #routelog .md-tabs .md-tab-header {
    min-width:70px;
  }

  #meinTenduTab.md-theme-default.md-tabs.md-transparent>.md-tabs-navigation {
    background-color: #E5F2F3 !important;
    border-bottom:none !important;
    position:fixed;
    width:100%;
    top:64px;
  }

  .md-menu-content.md-direction-bottom-left.md-active {
    position:fixed !important;
    top:76px !important;
  }

  .visible {
    display:block;
  }


</style>
